import './UpcomingDetails.css'
import home_goat from './data/home-goat.jpg'

const UpcomingDetails = (props) =>{
    return (
        <div className='container'>
            <h2 className='title' 
                onMouseEnter = {(e)=>{
                e.target.style.textDecoration = 'underline'
                e.target.style.cursor = 'pointer'}}
                onMouseLeave = {(e) => {e.target.style.textDecoration = 'initial'}}
                onClick={() => {window.open("https://meatsummits.com/summit-2023/")}}>
                {props.title}
            </h2>
            <img className='image' src={props.source}/>
            <img className='image' src={props.source2}/>
            <p className='description'> {props.description} </p>
        </div>
    )

}

export default UpcomingDetails;